import * as React from 'react';

const Footer = () => (
  <footer className="bg-theme-red h-16 text-white font-bold flex items-center">
    <span className="text-center w-full">&#169; 2020 Starter4Ten Limited</span>
  </footer>
);

export default Footer;
